<!-- Displaying all the alloys created by a customer-->
<!-- loader -->
<ng-container *ngIf='loading'>
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- end of loader -->

<ng-container *ngIf="role && role !== 'CUSTOMER'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<!-- veryfying role of user -->
<ng-container *ngIf="role && role === 'CUSTOMER'">
  <div class="wrapper ">
    <br>
    <div>
      <div class="content">
        <ng-container *ngIf="alloys">
          <div class="alert alert-danger" role="alert" *ngIf="alloys.length === 0">
            No Alloys
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="alloys.length !== 0">
            Your Alloys
          </div>
          <div class="card">
          <div class="card-body">


            <div class="form-container">
              <form [formGroup]="filterForm" autocomplete="off">


                <div class="filter-container">
                <!--
                  <div>
                  <mat-form-field appearance="fill">
                  <mat-label >Created Between: </mat-label>
                  <mat-date-range-input [rangePicker]="picker" >
                    <input formControlName="startDate" matStartDate placeholder="Start date" >
                    <input formControlName="endDate" matEndDate placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                </div> -->

                <div>
                  
                  <!-- <mat-radio-group formControlName="iron1" required>
                    <mat-radio-button value="Grey Iron"><h6 id="head">Grey Iron</h6></mat-radio-button>&nbsp;&nbsp;
                    <mat-radio-button value="Ductile Iron"><h6 id="head">Ductile Iron</h6></mat-radio-button>
                  </mat-radio-group> -->
                  <mat-form-field appearance="fill" style="margin: 0 auto;">
                    <mat-label >CLASS : </mat-label>
                    <mat-select formControlName="iron1" required>
                      <mat-option *ngFor="let type of gIron" [value]="type">
                        {{ type }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  
                  <!-- <mat-radio-group formControlName="iron2" required>
                    <mat-radio-button value="Base Iron"><h6 id="head">Base Iron</h6></mat-radio-button>&nbsp;&nbsp;
                    <mat-radio-button value="Final Iron"><h6 id="head">Final Iron</h6></mat-radio-button>
                  </mat-radio-group> -->
                  <mat-form-field appearance="fill" style="margin: 0 auto;">
                    <mat-label >IRON TYPE: </mat-label>
                    <mat-select formControlName="iron2" required>
                      <mat-option *ngFor="let type of ironType" [value]="type">
                        {{ type }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


                <!-- <div>
                  <h5 class="card-title">GRADE :</h5>
                  <input id="nameright" type="text" class="card3" formControlName="grade">
                </div> -->
                <div>
                  <mat-form-field appearance="fill" style="margin: 0 auto;">
                    <mat-label >GRADE: </mat-label>
                    <mat-select formControlName="grade" required>
                      <mat-option *ngFor="let type of drp_grade1" [value]="type">
                        {{ type }}
                         </mat-option>
                         </mat-select>
                      </mat-form-field>

                 <!-- <h5 class="card-title">GRADE :</h5>
                  <input id="nameright" type="text" class="card3" formControlName="grade" >

                -->
              </div>


                </div>
                  
                <div class="button-container">
                    <button type="button" class="btn btn-success" (click)="filter()">FILTER</button>
                    <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
                </div>
              <mat-error *ngIf="missingFields" style="margin-top: 10px;">All fields Required. Grade is optional.</mat-error>
              <br>
              <br>
            </form>
            </div>



            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <!-- <th scope="col">Alloy ID</th> -->
                  
                  <th scope="col">CLASS</th>
                  <th scope="col">TYPE</th>
                  <th scope="col">GRADE</th>
                  <th scope="col">DESCRIPTION</th>
                  <!--<th scope="col">Heat ID</th>-->
                  
                  <th scope="col">GEL</th>
                  <th scope="col">WEL</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let alloy of alloys">
                  <!-- <td>{{ alloy._id }}</td> -->
                 
                  
                  <!--<td>{{ alloy.heatNumber }}</td>-->
                  <td>
                    
                      {{ alloy.iron1 }}
                    
                  </td>
                  <td>
                    
                      {{ alloy.iron2 }}
                    
                  </td>
                  <td>{{ alloy.grade }}</td>
                  <td>{{ alloy.name }}</td>
                  <td>{{ alloy.calculatedValues.GEL }}</td>
                  <td>{{ alloy.calculatedValues.WEL }}</td>
                  <td>
                    <button type="button" class="btn btn-success" (click)="editAlloy(alloy)">	<mat-icon>edit</mat-icon>Edit</button>
                    <button [disabled]="alloy.curveGenerated" type="button" class="btn btn-danger" (click)="deleteAlloy(alloy)">
                      <mat-icon *ngIf="!alloy.curveGenerated">delete</mat-icon>
                      <mat-icon *ngIf="alloy.curveGenerated" [matTooltipPosition]="position" matTooltip="You cannot delete this alloy because Curve is already generated">delete</mat-icon>Delete
                    </button>
                    <button type="button" class="btn btn-primary" (click)="copyAlloy(alloy)">	<mat-icon>file_copy</mat-icon>Copy</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
